import {createStore, applyMiddleware, combineReducers} from 'redux'
import promiseMiddleware from 'redux-promise'
import reducer from '../reducers'
import * as actions from '../actions'

var createStoreWithMiddleware = applyMiddleware(
    promiseMiddleware
)(createStore)

var store = createStoreWithMiddleware(reducer)

if (process.env.MT_ENV === 'development') {
    store.subscribe(() =>
        console.log('State changed: ', store.getState())
    )
}

export default store



// WEBPACK FOOTER //
// ./state/store/index.js